/**
 * HealthCheck - Smoke test page
 * Minimal component to verify React is working without any dependencies
 */
export default function HealthCheck() {
  return (
    <div style={{
      width: '100%',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#10b981',
      color: 'white',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      flexDirection: 'column',
      gap: '1rem',
      padding: '2rem'
    }}>
      <div style={{ fontSize: '3rem' }}>✅</div>
      <h1 style={{ fontSize: '2rem', margin: 0 }}>Health Check: OK</h1>
      <p style={{ fontSize: '1rem', opacity: 0.9 }}>React is running correctly</p>
      <div style={{ fontSize: '0.875rem', opacity: 0.7, marginTop: '1rem' }}>
        {new Date().toISOString()}
      </div>
    </div>
  );
}
